<template>
  <div class="grid_flex justify-space-between mb-5">
    <v-card class="menu_team flex-grow-1 text-center ml-1 mr-1">
      <router-link class="menu_team_link" to="/sell/orderretailcustomers">
        <div class="menu_team_img">
          <img src="@/assets/order-food.png">
        </div>
        <div>
          คำสั่งซื้อลูกค้าปลีก   <v-badge  v-if="newOrderCountRetail !== null"   v-show="newOrderCountRetail > 0" color="red" :content="newOrderCountRetail" inline class=" blinking"/>
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team flex-grow-1 text-center ml-1 mr-1">
      <router-link class="menu_team_link" to="/sell/ordercustomermain">
        <div class="menu_team_img">
          <img src="@/assets/agreement.png">
        </div>
        <div>
          คำสั่งซื้อลูกค้าส่ง  <v-badge  v-if="newOrderCountWholesale !== null"   v-show="newOrderCountWholesale > 0" color="red" :content="newOrderCountWholesale" inline class=" blinking"/>
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team flex-grow-1 text-center ml-1 mr-1">
      <router-link class="menu_team_link" to="/sell/orderpartnermain">
        <div class="menu_team_img">
          <img src="@/assets/boxes_sell.png">
        </div>
        <div>
          คำสั่งซื้อพาร์ทเนอร์  <v-badge  v-if="newOrderCountPartners !== null"   v-show="newOrderCountPartners > 0" color="red" :content="newOrderCountPartners" inline class=" blinking"/>
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team flex-grow-1 text-center ml-1 mr-1">
      <router-link class="menu_team_link" to="/sell/orderothermain">
        <div class="menu_team_img">
          <img src="@/assets/customer_sell.png">
        </div>
        <div>
          คำสั่งอื่นๆ
        </div>
      </router-link>
    </v-card>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
export default {
  name: "MenuSell",
  data() {
    return {
      newOrderCountWholesale: null, // ให้รู้ว่ายังไม่โหลด
      newOrderCountRetail: null, // ให้รู้ว่ายังไม่โหลด
      newOrderCountPartners: null, // ให้รู้ว่ายังไม่โหลด
    }
  },
  methods: {
    async fetchNewOrderCountWholesale() {
      try {
        const res = await HTTP.get('/wholesales/orders/count-new-wholesale')
        this.newOrderCountWholesale = res.data.count
      } catch (error) {
        console.error('Fetch order count failed', error)
      }
    },
    async fetchNewOrderCountRetail() {
      try {
        const res = await HTTP.get('/wholesales/orders/count-new-retail')
        this.newOrderCountRetail = res.data.count
      } catch (error) {
        console.error('Fetch order count failed', error)
      }
    },
    async fetchNewOrderCountPartners() {
      try {
        const res = await HTTP.get('/wholesales/orders/count-new-Partners')
        this.newOrderCountPartners = res.data.count
      } catch (error) {
        console.error('Fetch order count failed', error)
      }
    }
  },
  mounted() {
    this.fetchNewOrderCountWholesale(),
    this.fetchNewOrderCountRetail(),
    this.fetchNewOrderCountPartners()
  },
}

</script>

<style scoped>

.blinking {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.4;
  }
}

.menu_team>.menu_team_link {
  color: #565656;
  padding: 10px 15px 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
}

.router-link-active,
.menu_team>.menu_team_link:hover {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d)!important;
  transition: 0.1s !important;
  border-radius: 4px;
  font-weight: 400;
}

.menu_team_img {
  margin: auto;
  width: 50px;
}

.menu_team_img>img {
  max-width: 100%;
}
.grid_flex {
  display: flex;
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
